import {
  AdminHeader,
  AdminSidebar,
  ButtonPro,
  Typography
} from 'components';
import AttendanceReport from 'components/template/AttendanceReport/AttendanceReport';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';
import LogoSVG from 'components/atoms/LogoSVG';
import { useAppDispatch, useAppSelector } from 'store';
import { fetchAttendanceRecords } from 'store/Attendance';

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
const yearOptions = Array.from({ length: 10 }, (_, i) => currentYear - i);

export const AttendanceSummary = () => {
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [selectedMonth, setSelectedMonth] = useState<number>(currentMonth);

  const dispatch = useAppDispatch();
  const { attendanceData, loading, error } = useAppSelector(
    (state) => state.attendance
  );

  useEffect(() => {
    dispatch(
      fetchAttendanceRecords({
        month: monthNames[selectedMonth],
        year: selectedYear
      })
    );
  }, [selectedYear, selectedMonth, dispatch]);

  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <div className="attendance-summary-container">
          {loading && (
            <div className="loading-overlay">
              <LogoSVG />
            </div>
          )}

          <div className="attendance-header">
            <div className="header-content">
              <div className="page-title">
                <Typography
                  text="Employee Attendance Summary"
                  type="base_regular"
                  weight="bold"
                />
                <Typography
                  text="Legacy monthly summary reports (pre-fingerprint tracking)"
                  type="small_regular"
                  className="page-subtitle"
                />
              </div>
            </div>

            <div className="attendance-controls">
              <div className="control-group">
                <label htmlFor="year-select">Year</label>
                <select
                  id="year-select"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="control-group">
                <label htmlFor="month-select">Month</label>
                <select
                  id="month-select"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(Number(e.target.value))}
                >
                  {monthNames.map((name, idx) => (
                    <option key={name} value={idx}>
                      {name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="attendance-content">
            {!loading && attendanceData && (
              <AttendanceReport
                monthName={attendanceData.monthName}
                year={attendanceData.year}
                holidays={attendanceData.holidays}
                workingDays={attendanceData.workingDays}
                attendanceRecords={attendanceData.attendanceRecords}
              />
            )}

            {!loading && !attendanceData && error && (
              <div className="upload-section">
                <Typography
                  text={`No legacy summary data for ${monthNames[selectedMonth]} ${selectedYear}`}
                  type="base_regular"
                  weight="bold"
                />
                <Typography
                  text="Import fingerprint punch data using the Attendance Tracking module."
                  type="small_regular"
                  className="upload-subtitle"
                />
                <Link to="/attendance-tracking/upload">
                  <ButtonPro label="Go to Fingerprint Upload" />
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
